import Main from "../components/layout/Main";
import React from "react";
import { Visualisations } from "../containers/QueryBuilder/visualisations/Visualisations";

export const VisualisationsPage = () => {
    return <Main title="Query Visualiser"><Visualisations/></Main>
}